export const TINGKATS_GET = 'TINGKATS_GET';
export const TINGKAT_JENJANGS_GET = 'TINGKAT_JENJANGS_GET';
export const TINGKAT_ADD = 'TINGKAT_ADD';
export const TINGKAT_EDIT = 'TINGKAT_EDIT';
export const TINGKAT_GET = 'TINGKAT_GET';
export const TINGKAT_DELETE = 'TINGKAT_DELETE';
